import register from '@kpsys/angularjs-register';
import tenderRoutes from './tender.routes';
import {TenderDataService} from './tender.data-service';
import {TenderService} from './tender.service';
import {DemandDataService} from './demand.data-service';
import {OfferDataService} from './offer.data-service';
import {TenderPresenter} from './tender.presenter';

export default register('portaro.features.tender')
    .config(tenderRoutes)
    .service(TenderDataService.serviceName, TenderDataService)
    .service(DemandDataService.serviceName, DemandDataService)
    .service(OfferDataService.serviceName, OfferDataService)
    .service(TenderService.serviceName, TenderService)
    .service(TenderPresenter.presenterName, TenderPresenter)
    .name();